import { autoinject } from "aurelia-framework";
import { Api } from 'app/shared/lib/api/api';
import { IQueryLoadOptions, IApiQueryResults, IApiActionResults } from 'app/shared/lib/api/api-types';
import * as UM from 'app/um/models/essette-api';

/**
 * Provides access to API models related to Auth Transportation
 */
@autoinject
export class TransportationService {

    ////****************** Fields and Properties ************************************////


    ////****************** Functions ************************************************////
    constructor(protected readonly api: Api) { }


    ////****************** Queries **************************************************////

    /**
     * Load all `UM.AuthTransportationAppointment` models
     * @param options query load options
     * @param includes related models to include
     */
    public async loadAppointments(options?: Partial<IQueryLoadOptions>, includes: string[] = []): Promise<IApiQueryResults<UM.AuthTransportationAppointment>> {
        const query = this.api
            .query('um/auths/transportation/appointments')
            .applyStandardLoadOptions(options)
            .include(...includes);
        return await this.api.get(query);
    }

    /**
     * Load all `UM.AuthTransportationAppointment` models
     * @param authId load appointments for this auth
     * @param options query load options
     * @param includes related models to include
     */
    public async loadAppointmentsByAuth(authId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<UM.AuthTransportationAppointment>> {
        const query = this.api
            .query(`um/auths/${authId}/transportation/appointments`)
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);
        return await this.api.get(query);
    }

    ////****************** Loads ****************************************************////

    /**
     * Loads a single `UM.AuthTransportationAppointment` model
     * @param appointmentId the id of the appointment to load
     * @param includes related models to include
     */
    public async loadAppointment(appointmentId: string, includes: string[] = []): Promise<IApiQueryResults<UM.AuthTransportationAppointment>> {
        const query = this.api
            .query(`um/auths/transportation/appointments/${appointmentId}`)
            .include(...includes);
        return await this.api.get(query);
    }

    ////****************** Actions **************************************************////

    /**
     * Inserts or Updates a `UM.AuthTransportationAppointment` record
     * @param appointment the appointment object to save
     */
    public async saveAppointment(appointment: UM.AuthTransportationAppointment): Promise<IApiActionResults> {
        const actionName = !!appointment.id ? 'update' : 'insert';
        const actionUrl = `um/auths/transportation/appointments` + (appointment.id ? `/${appointment.id}` : '');

        const action = this.api.action(actionName, actionUrl, appointment);
        return await this.api.post(action);
    }

    /**
     * Delete a `UM.AuthTransportationAppointment` record
     * @param appointmentId the ID of the appointment to delete
     */
    public async deleteAppointment(appointmentId: string): Promise<IApiActionResults> {
        const action = this.api.action('delete', `um/auths/transportation/appointments/${appointmentId}`, {});
        return await this.api.delete(action);
    }

}
